const TOKEN_KEY = 'acct4cast_token';

// Auth-aware fetch — automatically adds JWT header
// Redirects to /login on 401
export async function authFetch(url, options = {}) {
  const token = localStorage.getItem(TOKEN_KEY);

  const headers = {
    ...options.headers,
    ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
  };

  const response = await fetch(url, { ...options, headers });

  // Token expired or invalid — redirect to login
  if (response.status === 401) {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem('acct4cast_user');
    window.location.href = '/login';
    throw new Error('Session expired — please log in again');
  }

  return response;
}